/**
 * Debug Utility
 * Centralizes debug logging behind a flag for production builds
 * 
 * Usage:
 *   import { debug, debugWarn, debugError } from './utils/debug';
 *   debug.log('[AUTH]', 'Login successful');
 *   debug.warn('[PERF]', 'Slow render detected');
 *   debug.error('[API]', 'Request failed', error);
 */

// Enable debug logging in development only
const IS_DEBUG = process.env.NODE_ENV === 'development' || 
                 process.env.REACT_APP_DEBUG === 'true' ||
                 localStorage.getItem('debug_mode') === 'true';

// Namespaced loggers for different areas
const NAMESPACES = {
  AUTH: '[AUTH]',
  API: '[API]',
  GUEST: '[GUEST]',
  MEALS: '[MEALS]',
  MIQ: '[MIQ]',
  UI: '[UI]',
  PERF: '[PERF]',
  DEV: '[DEV]'
};

const debug = {
  log: (...args) => {
    if (IS_DEBUG) console.log(...args);
  },
  warn: (...args) => {
    if (IS_DEBUG) console.warn(...args);
  },
  error: (...args) => {
    // Always log errors, even in production
    console.error(...args);
  },
  info: (...args) => {
    if (IS_DEBUG) console.info(...args);
  },
  // Namespaced shortcuts
  auth: (...args) => {
    if (IS_DEBUG) console.log(NAMESPACES.AUTH, ...args);
  },
  api: (...args) => {
    if (IS_DEBUG) console.log(NAMESPACES.API, ...args);
  },
  guest: (...args) => {
    if (IS_DEBUG) console.log(NAMESPACES.GUEST, ...args);
  },
  meals: (...args) => {
    if (IS_DEBUG) console.log(NAMESPACES.MEALS, ...args);
  },
  miq: (...args) => {
    if (IS_DEBUG) console.log(NAMESPACES.MIQ, ...args);
  },
  ui: (...args) => {
    if (IS_DEBUG) console.log(NAMESPACES.UI, ...args);
  },
  dev: (...args) => {
    if (IS_DEBUG) console.log(NAMESPACES.DEV, ...args);
  }
};

// Export for use in components
export { debug, IS_DEBUG, NAMESPACES };
export default debug;
